// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2lf2b","title":"Header_title__11B_L","side":"Header_side__3CET9"};